import { useMutation } from "@tanstack/react-query";
import { managerLoginApi } from "components/api/member";
import { PAGE_ID_HOME } from "components/constent";
import { route } from "components/layout/router";
import { apifield } from "components/utils/comm";
import useAuthStore from "store/auth";
import useMdiStore from "store/menus";
import useUserStore from "store/user";

const menuIds = [
  "home",
  "member_user",
  "room_current",
  "room_resv",
  "room_resv_cancel",
  "room_product",
  "room_history",
  "room_room",
  "room_option",
];
export const useLoginApi = () => {
  const { setMenuList, setActivePage } = useMdiStore();
  const setIsLogin = useAuthStore((state) => state.setIsLogin);
  const setUser = useUserStore((state) => state.setUser);

  return useMutation({
    mutationFn: managerLoginApi,
    onSuccess: (res, variables) => {
      if (res) {
        //로그인시 해당 회원이 접속가능한 메뉴 리스트 받아옴
        // 그 메뉴 리스트로 메뉴를 다시 그림, 조회, 상세, 등록, 수정

        const {
          status: { code, message },
          data,
        } = res;

        if (code === 0) {
          //로그인 후 받은 menuId로 메뉴 등록
          const tab1 = route.filter((_route: any) => {
            const regex = _route.id.split("_")[0];
            return menuIds.some((item) => item.includes(regex));
          });

          const newMenus = tab1.map((_tab1: any) => {
            const menu = _tab1.menu.filter((item: any) => {
              return menuIds.includes(item.id);
            });

            return {
              ..._tab1,
              menu,
            };
          });
          setActivePage(PAGE_ID_HOME);
          setMenuList(newMenus);
          setUser({
            ...data.manInf,
            emlId: variables.emlId,
          });

          setIsLogin(true);

          //   formRef.current?.reset();
        }
        if (code !== 0) {
          apifield(message);
        }
      }
    },
  });
};
